import script from "./UploadLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadLogo.vue?vue&type=script&setup=true&lang=js"

import "./UploadLogo.vue?vue&type=style&index=0&id=46274f7f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46274f7f"]])

export default __exports__